var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "217px",
    height: "217px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 19,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0.12755102040816327s",
    calcMode: "discrete"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 19,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0.25510204081632654s",
    calcMode: "discrete"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 40,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0.8928571428571429s",
    calcMode: "discrete"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 40,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0.3826530612244898s",
    calcMode: "discrete"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 61,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0.7653061224489796s",
    calcMode: "discrete"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 61,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0.6377551020408163s",
    calcMode: "discrete"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 61,
    width: 20,
    height: 20,
    fill: "#3f78c9"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "#2ad3f8;#3f78c9;#3f78c9",
    keyTimes: "0;0.125;1",
    dur: "1.0204081632653061s",
    repeatCount: "indefinite",
    begin: "0.5102040816326531s",
    calcMode: "discrete"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.4ac6fb1ae7f7e9fac241b992a6a4c223.svg";
export { ForwardRef as ReactComponent };